import React from "react";
import HashLoader from "react-spinners/HashLoader";

const HashLoaderC = () => {
  return (
    <div className="">
      <HashLoader color="#36d7b7" />
    </div>
  );
};

export default HashLoaderC;
